export const staffViewToken = window.crypto.randomUUID();
